'use client';

import { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PersonCard } from '@/components/shared/PersonCard';

interface PeopleCarouselProps {
  people: any[];
}

export function PeopleCarousel({ people }: PeopleCarouselProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const containerWidth = scrollRef.current.clientWidth;
      const scrollAmount = containerWidth / 3;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => scroll('left')}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 flex h-[2.5rem] w-[2.5rem] items-center justify-center rounded-full bg-white/10 text-white hover:bg-primary hover:text-navy transition-all duration-300"
        style={{ marginLeft: '10px' }}
        aria-label="Scroll left"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>

      <button
        onClick={() => scroll('right')}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 flex h-[2.5rem] w-[2.5rem] items-center justify-center rounded-full bg-white/10 text-white hover:bg-primary hover:text-navy transition-all duration-300"
        style={{ marginRight: '10px' }}
        aria-label="Scroll right"
      >
        <ChevronRight className="h-5 w-5" />
      </button>

      <div
        ref={scrollRef}
        className="flex gap-[0.3rem] overflow-x-auto pb-4 scrollbar-hide snap-x"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {people.map((person) => (
          <div
            key={person.slug}
            className="person-card-wrapper shrink-0 snap-start w-full sm:w-[calc((100%-2rem)/2)] lg:w-[calc((100%-3rem)/3)]"
          >
            <PersonCard
              slug={person.slug}
              name={person.name}
              position={person.position}
              image={person.image}
              variant="dark"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
